import { send } from '../../../../../../src/network/network';
import { type PatchedQuiz } from '../../../../../../src/types/PatchedQuiz';
import { type Quiz } from '../../../../../../src/types/Quiz';

type Params = {
  quiz: PatchedQuiz;
};

export async function patchApiV2CustomersCustomerIdQuizzes({ quiz }: Params) {
  return await send<Quiz>({
    path: `/api/v2/customers/self/quizzes/`,
    method: 'PATCH',
    body: quiz,
  });
}
